<template>
    <div class="sticky-bottom fixed-bottom">
        <b-button
            v-for="(link, index) in routerLinks"
            :key="index"
            :to="{ name: link.name }"
            :id="`new_button${index}`"
            variant="primary"
            class="mr-2"
        >
            {{ link.title || $t('menuItemNew') }}
            <span class="pl-1 fa fa-plus"></span>
        </b-button>
    </div>
</template>
<script>
    export default { props: { routerLinks: { type: Array, required: true } } };
</script>
